/**
 * Header compartido (Categorias, Tareas, ListaTests, páginas estáticas).
 * Con lenguajeId=4 muestra los 4 links; con 1/2 solo "Páginas de interés" (como el sitio original).
 */
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getInstallPrompt, clearInstallPrompt, getDeviceId, detectDevice } from '../../lib/installPrompt';
import { maybeAutoSubscribeToPush } from '../../lib/pushNotifications';
import { uiLabels } from '../../lib/uiLabels';

export const NAV_LINKS_ALL = [
  { label: '¿CÓMO USAR\nEL LABPSI?', href: 'https://www.youtube.com/watch?v=NWdT_wveBF8', external: true, ids: [4] },
  { label: 'RECIBA\nNOVEDADES', href: 'https://forms.gle/c3p1GrQjmWcs8mgJA', external: true, ids: [4] },
  { labelKey: 'pagesOfInterest', href: '/links', external: false, ids: [1, 2, 4] },
  { label: 'PARA\nPROFESIONALES', href: 'https://drive.google.com/file/d/154RhUlgAB3bu9zr_hJW_b-_VdyR-KXbx/view?usp=sharing', external: true, ids: [4] },
];

/** @deprecated use NAV_LINKS_ALL */
export const NAV_LINKS = NAV_LINKS_ALL.map(({ label, labelKey, href, external }) => ({
  label: label ?? labelKey,
  href,
  external,
}));

export default function SiteHeader({ lenguajeId, minimal = false }) {
  const [installPrompt, setInstallPrompt] = useState(() => getInstallPrompt());
  const [menuOpen, setMenuOpen] = useState(false);
  const id = lenguajeId != null ? Number(lenguajeId) : null;
  const labels = uiLabels(id);

  const links = minimal
    ? []
    : (id ? NAV_LINKS_ALL.filter((l) => l.ids.includes(id)) : NAV_LINKS_ALL);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    const onReady = () => setInstallPrompt(getInstallPrompt());
    window.addEventListener('pwa:installready', onReady);
    return () => window.removeEventListener('pwa:installready', onReady);
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) return;
    // Pedir el permiso de notificaciones ACA, dentro del click: es el único
    // momento con gesto de usuario "fresco". Si se espera a 'appinstalled',
    // el navegador puede ignorar/silenciar el pedido de permiso.
    maybeAutoSubscribeToPush(getDeviceId(), detectDevice());
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') { clearInstallPrompt(); setInstallPrompt(null); }
  };

  const showToggle = !minimal && links.length > 0;

  return (
    <div className="site-header-bar">
      <div className={`site-header-inner menu-top${menuOpen ? ' menu-open' : ''}`}>
        <Link to="/" className="logo-container" onClick={() => setMenuOpen(false)}>
          <img className="logo" src="/assets/img/logo.png" alt="" />
          <div>
            <img className="logo-letra" src="/assets/img/logo-letra-blanco.png" alt="LABPSI" />
            <div className="logo-inicio">{labels.home}</div>
          </div>
        </Link>

        {showToggle && (
          <button
            type="button"
            className="site-header-toggle"
            aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={menuOpen}
            aria-controls="site-header-nav"
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
        )}

        <nav
          id="site-header-nav"
          className={`site-header-nav${menuOpen ? ' is-open' : ''}`}
          aria-label="Principal"
        >
          {links.map((link) => {
            const to = !link.external && link.href === '/links' && id
              ? `/links?lenguaje=${id}`
              : link.href;
            const label = link.labelKey ? labels[link.labelKey] : link.label;
            return link.external ? (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="site-header-link"
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </a>
            ) : (
              <Link
                key={link.href}
                to={to}
                className="site-header-link"
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </Link>
            );
          })}
          {!minimal && installPrompt && (
            <button type="button" onClick={handleInstall} className="site-header-link site-header-install">
              {labels.installApp}
            </button>
          )}
        </nav>
      </div>
    </div>
  );
}
